import { POST } from "../constants/request-type";
import {
  create_secure_upload_web,
  create_upload_web,
  upload
} from "../constants/routes";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "./axios";

const uploadFile = async (data) => {
  const file = new FormData();
  file.append("file", data);

  const request_details = {
    type: POST,
    url: service_api,
    route: upload + "/" + create_upload_web,
    data: file,
    token: null
  };

  const response = await MakeRequestAsync(request_details);
  return response;
};

const uploadSecureFile = async (data, token) => {
  const file = new FormData();
  file.append("file", data);

  const request_details = {
    type: POST,
    url: service_api,
    route: upload + "/" + create_secure_upload_web,
    data: file,
    token: token
  };

  const response = await MakeRequestAsync(request_details);
  return response;
};

export { uploadFile, uploadSecureFile };
